import { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { MarkingNotification } from '@/hooks/use-marking-notifications';

interface MarkingsByHourChartProps {
  data: MarkingNotification[];
}

export function MarkingsByHourChart({ data }: MarkingsByHourChartProps) {
  const chartData = useMemo(() => {
    const hourlyData: Record<number, { hour: string; fuel: number; odometer: number }> = {};

    // Initialize all hours
    for (let i = 0; i < 24; i++) {
      hourlyData[i] = {
        hour: `${i.toString().padStart(2, '0')}:00`,
        fuel: 0,
        odometer: 0,
      };
    }

    // Count markings by hour
    data.forEach((notification) => {
      const hour = new Date(notification.created_at).getHours();
      if (notification.marking_type === 'fuel') {
        hourlyData[hour].fuel++;
      } else {
        hourlyData[hour].odometer++;
      }
    });

    return Object.values(hourlyData);
  }, [data]);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis 
          dataKey="hour" 
          className="text-xs"
          tick={{ fill: 'hsl(var(--muted-foreground))' }}
        />
        <YAxis 
          className="text-xs"
          tick={{ fill: 'hsl(var(--muted-foreground))' }}
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'hsl(var(--popover))',
            border: '1px solid hsl(var(--border))',
            borderRadius: '0.5rem',
          }}
        />
        <Legend />
        <Bar 
          dataKey="fuel" 
          fill="hsl(var(--primary))" 
          name="Abastecimentos"
          radius={[4, 4, 0, 0]}
        />
        <Bar 
          dataKey="odometer" 
          fill="hsl(var(--chart-2))" 
          name="Marcações KM"
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
